import React from 'react';
import { 
	string, 
	func, 
	array,
} from 'prop-types';
import {Editor, ContentState, EditorState, Modifier, CompositeDecorator} from 'draft-js';
import {AsnwerExpression_g, removeAnswerExpressions, findoutTextType} from '../../../logics/questionBuilder';
import style from './style';

function answerTextStrategy(contentBlock, callback) {
	const text = contentBlock.getText();
	let matchArr = AsnwerExpression_g.exec(text), start;
	while (matchArr !== null) {
		start = matchArr.index;
		callback(start, start + matchArr[0].length);
		matchArr = AsnwerExpression_g.exec(text);
	}
}

const AnswerComponent = (props) => {
	return <style.AnswerText>{props.children}</style.AnswerText> ;
};

AnswerComponent.propTypes ={
	children:array.isRequired
};

export default class QuizEditorContainer extends React.Component {
	static propTypes = {
		initText:string,
		render:func
	}
	static constructState = (initText) => {
		let editorState = EditorState.createEmpty();
		const decorators = new CompositeDecorator([{
			strategy: answerTextStrategy,
			component: AnswerComponent,
		}]);
		if(initText){
			const contentState = ContentState.createFromText(initText);
			editorState = EditorState.createWithContent(contentState,decorators);
		}
		return {
			editorState
		};
	}

	constructor(props) {
		super(props);
		this.state = QuizEditorContainer.constructState(props.initText);
	}

	extractSelectedText = (editorState) => {
		const selectionState = editorState.getSelection();
		const anchorKey = selectionState.getAnchorKey();
		const currentContent = editorState.getCurrentContent();
		const currentContentBlock = currentContent.getBlockForKey(anchorKey);
		const start = selectionState.getStartOffset();
		const end = selectionState.getEndOffset();
		const selectedText = currentContentBlock.getText().slice(start, end);
		return {
			selectionState,
			selectedText
		};
	}
	handleModifyText = (modifier)=>{
		const {editorState} = this.state;
		const {selectionState,selectedText} = this.extractSelectedText(editorState);
		const replacedText = modifier(selectedText);
		const newContentState = Modifier.replaceText(editorState.getCurrentContent(),selectionState,replacedText);
		const newEditorState = EditorState.set(editorState, { currentContent: newContentState });
		this.setState({ editorState: EditorState.moveFocusToEnd(newEditorState) });
	}

	handleMarkAsAnswer = ()=>{
		this.handleModifyText(selectedText=>{
			const removedAnswerExpression = removeAnswerExpressions(selectedText);
			return `%A{${removedAnswerExpression}}`;
		});
	}
	handleAddLeftsideOfBlankCode = ()=>{
		this.handleModifyText((selectedText)=>{
			return selectedText ? `%A{${selectedText}` : '%A{';
		});
	}
	handleAddRightsideOfBlankCode = ()=>{
		this.handleModifyText((selectedText)=>{
			return selectedText ? `${selectedText}}` : '}';
		});
	}
	handleRemoveAnswerExpression = ()=>{
		this.handleModifyText(selectedText=>{
			return removeAnswerExpressions(selectedText);
		});
	}


	render(){
		const {render} = this.props;
		const {editorState} = this.state;
		const currentContent = editorState.getCurrentContent();
		const plainText = currentContent.getPlainText();
		const editorProps = {
			editor:	
			<Editor 
				editorState={editorState} 
				onChange={(editorState)=>{
					this.setState({editorState:editorState});
				}} 
				spellCheck={true}
			/>,
			selectedTextType : findoutTextType(this.extractSelectedText(editorState).selectedText),
			handleMarkAsAnswer:this.handleMarkAsAnswer,
			handleRemoveAnswerExpression:this.handleRemoveAnswerExpression,
			handleAddLeftsideOfBlankCode : this.handleAddLeftsideOfBlankCode,
			handleAddRightsideOfBlankCode:this.handleAddRightsideOfBlankCode
		};

		return render({
			editorProps,
			plainText,
			editorState}); 
			
	}
}
